<template>
  <ErrorPage :layout="me ? 'default' : 'login'" />
</template>

<script setup lang="ts">
import ErrorPage from '#common/error.vue'

const { data: me } = useAuth()
</script>
